// ============================================
// COMPONENT: ChangePasswordView
// ============================================
// Archivo: src/components/auth/ChangePasswordView.jsx

import React, { useState } from 'react';
import { Lock } from 'lucide-react';

const ChangePasswordView = ({ onSubmit, onSuccess }) => {
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!newPassword) {
      alert('Por favor ingresa una contraseña');
      return;
    }

    setLoading(true);
    const result = await onSubmit(newPassword);
    setLoading(false);

    if (result.success) {
      onSuccess();
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <Lock size={64} className="text-blue-600 mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-gray-900">
            Cambio Obligatorio de Contraseña
          </h1>
          <p className="text-gray-600 mt-2">
            Por seguridad, debes cambiar tu contraseña temporal
          </p>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <p className="font-semibold text-blue-900 mb-2">
            La contraseña debe:
          </p>
          <ul className="list-disc list-inside text-blue-800 space-y-1 text-sm">
            <li>Contener letras (a-z, A-Z)</li>
            <li>Contener números (0-9)</li>
            <li>Tener al menos 8 caracteres</li>
          </ul>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Nueva Contraseña
            </label>
            <input
              type="password"
              placeholder="Ej: MiPassword123"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Guardando...' : 'Guardar Nueva Contraseña'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordView;
